import { createFileRoute } from "@tanstack/react-router";
import { usersListSearchSchema } from "@/features/admin/users/_configs/users-list-search-schema";
import { TechniciansList } from "@/features/admin/users/list/technicians-list";

export const Route = createFileRoute("/admin/users/technicians")({
  validateSearch: usersListSearchSchema,
  component: TechniciansList,
});
